<template>
  <div>
    <v-layout row align-center>
      <v-flex>
        <b>{{ notification.name }}</b>
        <p>{{ notification.description }}</p>
        <div>
          Currently
          <span v-if="notification.NotificationSetting">{{
            notification.NotificationSetting.metadata.phoneNumbers.length
            }}</span>
          <span v-else>0</span> Phone number(s) set.
        </div>
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn v-if="notification.NotificationSetting" class="v-btn-with-radius" color="teal" dark @click="open()">{{
        $t('buttons.edit') }}</v-btn>
      <div v-if="!notification.NotificationSetting">
        <v-btn class="v-btn-with-radius" color="info" @click="open()">{{
          $t('buttons.enable')
          }}</v-btn>
      </div>
      <div v-else>
        <v-btn class="v-btn-with-radius" color="error" @click="disableNotification(notification)">{{
          $t('buttons.disable') }}</v-btn>
      </div>
    </v-layout>
    <v-dialog persistent v-model="dialog" max-width="700px">
      <v-card class="outlined rounded-border">
        <CardToolbar title="Text Alerts (Free)" :isModal="true" @cancel="cancel" />
        <v-container grid-list-md>
          <v-layout column>
            <v-flex>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-layout column>
                    <v-flex>
                      <div>Phone Number</div>
                      <div><small>limit 2 number</small></div>
                      <v-layout row>
                        <v-flex>
                          <v-text-field solo clearable :hide-details="phoneNumberErrors.length === 0"
                            :error-messages="phoneNumberErrors" mask="phone" dense
                            v-model="salesAlertDialog.phoneNumber"></v-text-field>
                        </v-flex>
                        <v-flex shrink>
                          <v-btn color="pink" class="v-btn-with-radius mt-0" @click="addSalesAlertPhoneNumber"
                            :disabled="$v.salesAlertDialog.$invalid ||
                              salesAlert.phoneNumbers.length > 1
                              ">Add</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex>
                      <v-list v-if="salesAlert.phoneNumbers.length">
                        <template v-for="(number, index) in salesAlert.phoneNumbers">
                          <v-list-tile :key="number">
                            <v-list-tile-action>
                              <v-btn fab flat @click.stop.prevent="deletePhoneNo(index)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-list-tile-action>
                            <v-list-tile-content>{{
                              number | phone
                              }}</v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-layout column>
                    <v-flex>
                      <div>{{ $t('labels.time') }}</div>
                      <div><small>limit 2</small></div>
                      <v-layout row>
                        <v-flex>
                          <timePicker v-model="selectedTime" />
                        </v-flex>
                        <v-flex shrink>
                          <v-btn block color="pink" class="v-btn-with-radius" @click="addSalesAlertTime"
                            :disabled="!disabledTimeButton || salesAlert.times.length > 2">{{ $t('buttons.add')
                            }}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex>
                      <v-list v-if="salesAlert.times.length">
                        <template v-for="(time, index) in salesAlert.times">
                          <v-list-tile :key="time.cron">
                            <v-list-tile-action>
                              <v-btn fab flat @click.stop.prevent="deleteTime(index)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-list-tile-action>
                            <v-list-tile-content>{{ time.label }}</v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row wrap align-center v-if="salesAlert.phoneNumbers.length">
                <v-flex xs12 md9>
                  <span class="font-weight-medium">Message</span>
                  <p class="font-weight-light">Select Values that you like to received as a text message.</p>
                </v-flex>
                <v-flex shrink xs12 md3 lg2>
                  <v-dialog v-model="editAlert" width="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="warning" class="v-btn-with-radius" dark v-bind="attrs" v-on="on">
                        Options
                      </v-btn>
                    </template>

                    <v-card class="outlined rounded-border">
                      <CardToolbar title="Message Option" :isModal="true" @cancel="editAlert = false" />
                      <v-divider></v-divider>

                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12 md6>
                            <p>Selected Fields: {{ selectedCount }} / 8</p>
                            <v-checkbox v-for="field in fields" :key="field.value" hide-details color="primary"
                              :label="field.label" :value="field.value" :disabled="isFieldDisabled(field.value)"
                              v-model="salesAlert.selectedFields"></v-checkbox>
                          </v-flex>
                          <v-flex xs12 md6>
                            <div v-if="selectedCount > 0" class="selected-fields">
                              <p><strong>Currently Selected Fields:</strong></p>
                              <ul>
                                <!-- Loop through selectedFieldLabels to display the labels -->
                                <li v-for="label in salesAlert.selectedFields" :key="label">{{ label }}</li>
                              </ul>
                            </div>
                          </v-flex>
                        </v-layout>

                      </v-card-text>



                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-btn color="primary" flat @click="editAlert = false">
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>

                        <v-btn color="primary" @click="generateObject">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex>
              <v-layout row wrap align-center v-if="salesAlert.phoneNumbers.length">
                <v-flex xs12 md9>
                  <span class="font-weight-medium">{{ $t('labels.shift') }}</span>
                  <p class="font-weight-light">{{ $t('subTitle.shiftClosed') }}</p>
                </v-flex>
                <v-flex shrink xs12 md3 lg2>
                  <v-switch v-model="salesAlert.shiftClosed" color="teal"
                    :label="salesAlert.shiftClosed ? 'Enabled' : 'Disabled'"></v-switch>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex>
              <v-layout row wrap align-center v-if="salesAlert.phoneNumbers.length">
                <v-flex xs12 md9>
                  <span class="font-weight-medium">{{
                    $t('labels.invoiceDeleteAlert')
                    }}</span>
                  <p class="font-weight-light">{{ $t('subTitle.deleteInvoiceAlert') }}</p>
                </v-flex>
                <v-flex shrink xs12 md3 lg2>
                  <v-switch v-model="salesAlert.invoiceDeleteAlert" color="teal"
                    :label="salesAlert.invoiceDeleteAlert ? 'Enabled' : 'Disabled'"></v-switch>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>


        <CardActions @submit="submit" :loading="submitLoading"
          :disabled="salesAlert.phoneNumbers.length === 0 ? true : false" @cancel="cancel" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import locationService from '@/modules/Location/service'

import timePicker from '@/components/Controls/TimePicker.vue'

const { validationMixin } = require('vuelidate')
const { required, minLength } = require('vuelidate/lib/validators')

export default {
  props: ['notification', 'LocationId'],
  data() {
    return {
      editAlert: false,
      submitLoading: false,
      selectedTime: null,
      salesAlertDialog: {
        phoneNumber: '',
        time: null,
      },
      fields: [
        { label: 'Customer Count', value: 'customerCount' },
        { label: 'Average Invoice', value: 'averageInvoice' },
        { label: 'Revenue', value: 'revenue' },
        { label: 'Income', value: 'income' },
        { label: 'Card Sale', value: 'cardSale' },
        { label: 'Other Payment', value: 'otherPayment' },
        { label: 'Cash Sale', value: 'cashSale' },
        { label: 'Discount', value: 'discounts' },
        { label: 'Cash Expense', value: 'expense' },
        { label: 'Open Invoice', value: 'openInvoice' },
        { label: 'Surcharge Collected', value: 'surchargeCollected' },
        { label: 'Tax Collected', value: 'taxCollected' },
        { label: 'Cash In Hand', value: 'cashInHand' },
      ],
      selectedFieldsObject: null,
      salesAlert: {
        phoneNumbers: [],
        times: [],
        service: 'twilio',
        shiftClosed: false,
        invoiceDeleteAlert: false,
        selectedFields: [],
      },
      dialog: false,
      enableNotification: {},
    }
  },
  components: {
    timePicker,
  },
  computed: {
    selectedCount() {
      return this.salesAlert.selectedFields.length; // Count of selected fields
    },
    disabledTimeButton() {
      if (
        this.selectedTime &&
        this.selectedTime.hh &&
        this.selectedTime.mm &&
        this.selectedTime.A
      )
        return true
      return false
    },
    phoneNumberErrors() {
      const errors = []
      if (!this.$v.salesAlertDialog.phoneNumber.$dirty) return errors
      if (!this.$v.salesAlertDialog.phoneNumber.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.salesAlertDialog.phoneNumber.minLength)
        errors.push(this.$t('validations.validLetters10'))
      return errors
    },
  },
  // watch: {
  //   dialog(val) {
  //     if (val) {
  //       console.log('salesAlert', this.salesAlert)
  //     }
  //   },
  // },
  methods: {
    // handleSelectionChange() {
    //   // Optional: You can log or handle changes here if needed
    //   console.log('Selected Fields:', this.salesAlert.selectedFields);
    // },
    isFieldDisabled(fieldValue) {
      // Disable checkboxes if 8 fields are already selected and this field is not already selected
      return this.selectedCount >= 8 && !this.salesAlert.selectedFields.includes(fieldValue);
    },
    // openDialog() {
    //   // Preload fields when dialog is opened
    //   // this.selectedFields = [...this.predefinedSelection];
    //   this.editAlert = true; // Ensure dialog is open
    // },
    generateObject() {
      // this.selectedFieldsObject = this.fields.reduce((acc, field) => {
      //   acc[field.value] = this.this.salesAlert.selectedFields.includes(field.value);
      //   return acc;
      // }, {});
      // console.log(this.selectedFieldsObject);
      this.editAlert = false; // Close the dialog
    },
    async disableNotification() {
      this.$swal
        .fire({
          title: this.$t('messages.title.areYouSure'),
          text: this.$t('messages.text.disableSaleAlertNotification'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#D32F2F',
          cancelButtonColor: '#21BED5',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        })
        .then(async (result) => {
          if (result.value) {
            await locationService.Settings.Notifications.remove(
              this.LocationId,
              this.notification.NotificationSetting.id,
            )
              .then(() => {
                this.$emit('reload')
                this.$swal.fire(this.$t('messages.title.disabled'), '', 'success')
              })
              .catch((error) => {
                console.log(error)
              })
          }
        })
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    open() {
      this.dialog = true
      this.enableNotification.NotificationSetting = {
        NotificationId: this.notification.id,
        metadata: {},
        ...this.notification.NotificationSetting,
      }

      if (this.notification.NotificationSetting) {
        this.salesAlert.phoneNumbers = JSON.parse(
          JSON.stringify(this.notification.NotificationSetting.metadata.phoneNumbers),
        )
        this.salesAlert.times = JSON.parse(
          JSON.stringify(this.notification.NotificationSetting.metadata.times),
        )
        this.salesAlert.shiftClosed = JSON.parse(
          JSON.stringify(this.notification.NotificationSetting.metadata.shiftClosed),
        )
        if (this.notification.NotificationSetting.metadata && this.notification.NotificationSetting.metadata.invoiceDeleteAlert) {
          this.salesAlert.invoiceDeleteAlert = JSON.parse(
            JSON.stringify(
              this.notification.NotificationSetting.metadata.invoiceDeleteAlert,
            ),
          )
        }
        // console.log('this.notification.NotificationSetting.metadata.selectedFields', this.notification.NotificationSetting.metadata)

        if (this.notification.NotificationSetting.metadata && this.notification.NotificationSetting.metadata.selectedFields) {
          this.salesAlert.selectedFields = JSON.parse(
            JSON.stringify(this.notification.NotificationSetting.metadata.selectedFields))
        } else {
          this.salesAlert.selectedFields = ['revenue', 'income', 'cardSale', 'otherPayment', 'cashSale'];
        }
      }
    },
    async submit() {
      // console.log('submit buton press')
      if (this.salesAlert.phoneNumbers.length === 0) {
        this.$swal
          .mixin({
            toast: true,
            showConfirmButton: true,
            position: 'top-end',
            timer: 3000,
          })
          .fire({
            icon: 'error',
            title: 'Please add phone to list.',
          })
        return false
      }
      this.enableNotification.NotificationSetting = {
        ...this.enableNotification.NotificationSetting,
        metadata: this.salesAlert,
      }

      // this.enableNotification.NotificationSetting = {
      //   ...this.enableNotification.NotificationSetting,
      //   metadata: {
      //     ...this.salesAlert,
      //     selectedFields: this.AlertselectedFields, // Add selected fields to the saved object
      //   },
      // };


      this.submitLoading = true
      await locationService.Settings.Notifications.set(
        this.LocationId,
        this.enableNotification.NotificationSetting,
      )
      this.submitLoading = false
      this.$swal
        .mixin({
          toast: true,
          showConfirmButton: true,
          position: 'top-end',
          timer: 3000,
        })
        .fire({
          icon: 'success',
          title: this.$t('toastMessage.text.updated'),
        })
      this.cancel()
      this.$emit('reload')
    },
    async deleteTime(index) {
      this.$swal
        .fire({
          title: this.$t('messages.title.areYouSure'),
          text: this.$t('messages.text.youWontBeAbleToRevert'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#D32F2F',
          cancelButtonColor: '#21BED5',
          confirmButtonText: this.$t('buttons.yesDeleteIt'),
        })
        .then((result) => {
          if (result.value) {
            this.salesAlert.times.splice(index, 1)
            // this.$swal.fire(
            //   this.$t('messages.title.deleted'),
            //   this.$t('messages.text.timeClockIsDelete'),
            //   'success',
            // )
          }
        })
    },
    async deletePhoneNo(index) {
      this.$swal
        .fire({
          title: this.$t('messages.title.areYouSure'),
          text: this.$t('messages.text.youWontBeAbleToRevert'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#D32F2F',
          cancelButtonColor: '#21BED5',
          confirmButtonText: this.$t('buttons.yesDeleteIt'),
        })
        .then((result) => {
          if (result.value) {
            this.salesAlert.phoneNumbers.splice(index, 1)
            this.$swal.fire(
              this.$t('messages.title.deleted'),
              this.$t('messages.text.phoneNumberDeleted'),
              'success',
            )
          }
        })
    },
    convertTime(hh, mm, a) {
      let hours = Number(hh)
      const minutes = Number(mm)
      const AMPM = a
      if (AMPM == 'PM' && hours < 12) hours += 12
      if (AMPM == 'AM' && hours == 12) hours -= 12
      let sHours = hours.toString()
      let sMinutes = minutes.toString()
      if (hours < 10) sHours = `0${sHours}`
      if (minutes < 10) sMinutes = `0${sMinutes}`
      return `${sHours}:${sMinutes}`
    },
    addSalesAlertTime() {
      this.salesAlertDialog.time = this.convertTime(
        this.selectedTime.hh,
        this.selectedTime.mm,
        this.selectedTime.A,
      )

      const timezone = this.$moment.tz.guess()

      // this.salesAlert.times.push({
      //   time: this.salesAlertDialog.time,
      //   timezone,
      //   label: this.$moment(`2019-01-01T${this.salesAlertDialog.time}:00`).format(
      //     'hh:mm a',
      //   ),
      // })
      const isDuplicate = this.salesAlert.times.some(
        (item) => item.time === this.salesAlertDialog.time && item.timezone === timezone
      );
      if (isDuplicate) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Duplicate Time',
          text: 'This time is already added.',
        });
      } else {
        this.salesAlert.times.push({
          time: this.salesAlertDialog.time,
          timezone,
          label: this.$moment(`2019-01-01T${this.salesAlertDialog.time}:00`).format(
            'hh:mm a',
          ),
        });

        // this.$swal.fire({
        //   icon: 'success',
        //   title: 'Time Added',
        //   text: 'The time has been successfully added.',
        // });
      }

      this.salesAlertDialog.time = null
      this.selectedTime = null
      document.getElementById('timeselection').value = null
    },
    reset() {
      this.salesAlertDialog.phoneNumber = ''
      this.enableNotification = {}
      this.$v.$reset()
    },
    addSalesAlertPhoneNumber() {
      if (this.salesAlertDialog.phoneNumber.length === 0) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.$swal
            .mixin({
              toast: true,
              showConfirmButton: true,
              position: 'top-end',
              timer: 3000,
            })
            .fire({
              icon: 'error',
              title: this.$t('toastMessage.text.missingFields'),
            })
        }
      } else {
        if (
          this.salesAlert.phoneNumbers.indexOf(this.salesAlertDialog.phoneNumber) !== -1
        ) {
          this.$swal
            .mixin({
              toast: true,
              showConfirmButton: true,
              position: 'top-end',
              timer: 3000,
            })
            .fire({
              icon: 'error',
              title: this.$t('toastMessage.text.phoneNumberAlreadyExist'),
            })
          return false
        }

        this.salesAlert.phoneNumbers.push(this.salesAlertDialog.phoneNumber)
        this.salesAlertDialog.phoneNumber = null
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    salesAlertDialog: {
      phoneNumber: {
        required,
        minLength: minLength(10),
      },
    },
  },
}
</script>
